import { Observable } from 'rxjs/Observable';
import { ACTIONS_KEYS } from '../../store';
import { createWires } from '../wiring.util';
import { WIRE_FACTORY } from './wires.factory';

export const HISTORY_WIRES = createWires({
  addResultIDToClickedHistory: WIRE_FACTORY.dispatchAction(ACTIONS_KEYS.history.addResultIdToClicksHistory),
  addTermToHistories(observable: Observable<string>, { store }) {
    observable.subscribe(() => {
      store.dispatch(ACTIONS_KEYS.history.addQueryHistory, store.state.search.query);
      store.dispatch(ACTIONS_KEYS.history.addQueryToSessionQueryHistory, store.state.search.query);
    });
  },
  clearQueryHistory: WIRE_FACTORY.dispatchAction(ACTIONS_KEYS.history.clearQueryHistory),
  loadClickedResultHistory: WIRE_FACTORY.dispatchAction(ACTIONS_KEYS.history.loadClickedResultHistory),
  loadQueryHistory: WIRE_FACTORY.dispatchAction(ACTIONS_KEYS.history.loadQueryHistory),
  loadSessionQueryHistory: WIRE_FACTORY.dispatchAction(ACTIONS_KEYS.history.loadSessionQueryHistory),
  removeQueryHistoryTerm: WIRE_FACTORY.dispatchAction(ACTIONS_KEYS.history.removeQueryHistory),
  setEnabledQueryHistory: WIRE_FACTORY.dispatchAction(ACTIONS_KEYS.history.setEnabledQueryHistory)
});
